import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { GlobalConfig } from '@shared/configs';
import { PathAPP } from '@shared/constants';
import { AuthService } from '../store';

/** Keeps an authenticated user off the login page. */
export const guestGuard: CanActivateFn = () => {
  if (!GlobalConfig.enableAuthGuard) {
    return true;
  }

  const auth = inject(AuthService);
  const router = inject(Router);

  return auth.isLoggedIn() ? router.createUrlTree([PathAPP.job.list]) : true;
};
